import { Autocomplete, Box, Button, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, Icon, Paper, TextField, Typography } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { LinearProgress } from "@mui/material";
import { FormHandles } from "@unform/core";
import * as yup from 'yup';

import { AlertSnackBar, AutoCompleteDeCliente, FerramentaDeDetalhe } from "../../shared/components";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { VTextField, VForm, useVForm } from "../../shared/forms";
import { UnidadeService } from "../../shared/services/api/unidade/UnidadeService";
import { Environment } from "../../shared/environment";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

interface IFormData {
    nomeUnidade: string,
    cnpj?: string,
}
interface IFormDataValidation {
    nomeUnidade: string,
}

const formValidationSchema: yup.SchemaOf<IFormDataValidation> = yup.object().shape({
    nomeUnidade: yup.string().required("O nome da área é obrigatório"),
});

export const DetalheDeUnidade: React.FC = () => {
    const { idUnidade = 'nova' } = useParams<'idUnidade'>();
    const navigate = useNavigate();

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();

    const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [isLoading, setIsLoading] = useState(false);
    const [titulo, setTitulo] = useState('');

    const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

    const limparCampos = () => {
        formRef.current?.setData({
            nomeUnidade: ''
        });
    };

    useEffect(() => {
        if (localStorage.getItem("cnpj") === null || localStorage.getItem("cnpj") === "" || localStorage.getItem("cnpj") === undefined) {
            navigate(-1);
        } else {
            setCnpj(localStorage.getItem("cnpj"));
        }
    }, [localStorage.getItem("cnpj")]);

    useEffect(() => {
        if (idUnidade !== 'nova') {
            setIsLoading(true);
            setTitulo("Carregando...")
            UnidadeService.getById(idUnidade)
                .then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {
                        // se der erro, volta para a listagem para não ficar uma tela em branco
                        setAlert({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlert(undefined);
                        }, duracaoAlert);
                        navigate('/unidade');
                    } else {
                        setTitulo(result.nomeUnidade);
                        formRef.current?.setData(result);

                        //pegar os dados que não podem ser iguais para não serem enviados na request

                    }
                });
        } else {
            formRef.current?.setData({
                nomeUnidade: ''
            });
        }
    }, [idUnidade])

    const handleSave = (dados: IFormData) => {
        if (idUnidade === "nova") {
            if (cnpj === undefined || cnpj === null || cnpj == '') {
                setAlert({ tipoAlert: "erro", mensagem: "Selecione um cliente" });
                setTimeout(() => {
                    setAlert(undefined);
                }, duracaoAlert);
            }
        }
        formValidationSchema.validate(dados, { abortEarly: false }).then((dadosValidados) => {
            if (idUnidade === 'nova') {
                if (cnpj !== undefined && cnpj !== null && cnpj !== '') {
                    setIsLoading(true);

                    UnidadeService.create({ cnpj, ...dadosValidados })
                        .then((result) => {
                            setIsLoading(false);
                            if (result instanceof Error) {
                                setAlert({ tipoAlert: "erro", mensagem: result.message });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);
                            } else {
                                setAlert({ tipoAlert: "sucesso", mensagem: "Área cadastrada" });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);

                                if (isSaveAndReturn()) {
                                    navigate(-1)
                                } else {
                                    limparCampos();
                                }
                            }
                        });
                }

            } else {
                if (dadosValidados.nomeUnidade == titulo) {
                    setAlert({ tipoAlert: "erro", mensagem: "Nada foi alterado" });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                    setIsLoading(false);
                } else {
                    setIsLoading(true);

                    UnidadeService.update({ idUnidade: Number(idUnidade), ...dadosValidados })
                        .then((result) => {
                            setIsLoading(false);
                            if (result instanceof Error) {
                                setAlert({ tipoAlert: "erro", mensagem: result.message });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);
                            } else {
                                setAlert({ tipoAlert: "sucesso", mensagem: "Área alterada" });
                                setTimeout(() => {
                                    setAlert(undefined);
                                }, duracaoAlert);

                                //salvar e voltar
                                if (isSaveAndReturn()) {
                                    navigate(-1)
                                } else {
                                    setTitulo(dadosValidados.nomeUnidade);
                                }
                            }
                        });
                }
            }
        }).catch((errors: yup.ValidationError) => {
            const validationErrors: { [key: string]: string } = {};

            errors.inner.forEach(error => {
                if (!error.path) return;
                validationErrors[error.path] = error.message;
            });

            formRef.current?.setErrors(validationErrors);
        });
    }

    const handleDelete = () => {
        UnidadeService.toggleEnabledById(Number(idUnidade))
            .then(result => {
                if (result instanceof Error) {//verificar se deu erro
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                } else {
                    setAlert({ tipoAlert: "erro", mensagem: "Área desativada com sucesso" });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                    navigate('/unidade');
                }
            });
    }

    const [abrir, setAbrir] = useState(false);

    const handleCancel = () => {
        setAbrir(false);
    };

    return (

        <LayoutBaseDePagina
            titulo={idUnidade == 'nova' ? 'Nova área' : titulo}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoSalvarEVoltar
                    mostrarBotaoApagar={idUnidade !== 'nova'}
                    mostrarBotaoNovo={idUnidade !== 'nova'}

                    mostrarBotaoNovoCarregando={isLoading}
                    mostrarBotaoApagarCarregando={isLoading}
                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEVoltar={saveAndReturn}
                    aoClicarEmApagar={() => setAbrir(true)}
                    aoClicarEmNovo={() => navigate('/unidade/detalhe/nova')}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {alert !== undefined && (
                <>
                    {alert.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            <DialogConfirm
                AoConfirmar={handleDelete}
                titulo={"Dejesa realmente desativar a área?"}
                texto={"Ao confirmar, a área e tudo que está contida nela será desativado, para defazer a ação será necessário reativar-la na listagem de área desativada."}
                abrir={abrir}
                AoCancelar={handleCancel}
            />

            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}
            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

                <VForm ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>

                        <Grid container item direction="row" spacing={2}>

                            <Grid item xs={12} sm={12} md={4}>
                                <VTextField fullWidth label="Nome" placeholder="Digite o nome..." name="nomeUnidade" />
                            </Grid>

                        </Grid>

                    </Grid>
                </VForm>

            </Box>

        </LayoutBaseDePagina>
    )
}
